import { createContext, useCallback, useContext, useState } from "react";
import Modal from "./Modal";

const Ctx = createContext(() => Promise.resolve(false));
export const useConfirm = () => useContext(Ctx);

/** confirm({ title, message, confirmText, danger }) -> Promise<boolean> */
export function ConfirmProvider({ children }) {
  const [state, setState] = useState(null);
  const confirm = useCallback((opts) => new Promise((resolve) => setState({ ...opts, resolve })), []);
  const close = (v) => {
    state?.resolve(v);
    setState(null);
  };
  return (
    <Ctx.Provider value={confirm}>
      {children}
      <Modal
        open={Boolean(state)}
        title={state?.title || "Are you sure?"}
        onClose={() => close(false)}
        footer={
          <>
            <button type="button" className="btn btn-ghost" onClick={() => close(false)}>
              Cancel
            </button>
            <button type="button" className={`btn ${state?.danger ? "btn-danger" : ""}`} onClick={() => close(true)}>
              {state?.confirmText || "Confirm"}
            </button>
          </>
        }
      >
        <p>{state?.message}</p>
      </Modal>
    </Ctx.Provider>
  );
}
